import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import { CommonText } from "components/Common/TextCommon";
import { LIST_ITEM, DATA_CURRENT } from "constants/dataDashboard";
import ChartDashboard from "components/Common/ChartDashboard";
import ListOfItem from "components/Common/ListOfItem";
import CardDetail from "components/Common/CardDetail";
import { formatData } from "helpers/erp_helper";
import httpService from "services/httpService";
import moment from "moment/moment";
import _ from "lodash";

const DATE_FORMAT = "YYYY-MM-DD";

export default function Dashboard() {
  const [incomeChartMonth, setIncomeChartMonth] = useState([]);
  const [incomeChartDay, setIncomeChartDay] = useState([]);
  const [summaryDashboard, setSummaryDashboard] = useState();
  const [dataCurrent, setDataCurrent] = useState(DATA_CURRENT);

  useEffect(() => {
    // getDataForIncomeChart(
    //   moment().startOf("month").format(DATE_FORMAT),
    //   moment().endOf("month").format(DATE_FORMAT)
    // ).then(result => setIncomeChartMonth(result));
    // getDataForIncomeChart(
    //   moment().startOf("day").format(DATE_FORMAT),
    //   moment().endOf("day").format(DATE_FORMAT)
    // ).then(result => setIncomeChartDay(result));
    // getSummaryDashboard();
  }, []);

  const getDataForIncomeChart = async (dateFrom, dateTo) => {
    const url = "parse/functions/order-summary";
    try {
      const resp = await httpService.post(url, { dateFrom, dateTo });
      if (resp.result && resp.result.statusCode === 201) {
        return resp.result.data;
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getSummaryDashboard = async () => {
    try {
      const res = await httpService.post("parse/functions/dashboard-summary");

      if (res.result && res.result.statusCode) {
        setSummaryDashboard(res.result.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getCount = index => {
    switch (index) {
      case 1:
        return summaryDashboard?.contractCount;
        break;
      case 2:
        return summaryDashboard?.totalContractCount;
        break;
      case 3:
        return summaryDashboard?.totalEmployee;
        break;
      case 4:
        return summaryDashboard?.customerCout;
        break;
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <CommonText level={3} color="#1A1A1A" mb={17}>
          Dashboard
        </CommonText>

        {/* <Row>
          {LIST_ITEM.map(item => (
            <Col xl={3} key={item.id}>
              <CardDetail item={item} number={getCount(item.id)} />
            </Col>
          ))}
        </Row>
        <Row>
          <Col xl={6}>
            <ChartDashboard
              title={"Doanh thu tháng " + moment().format("MM")}
              typeDefault="bar"
              data={formatData(incomeChartMonth, ["objectId", "total"])}
            />
          </Col>
          <Col xl={6}>
            <ListOfItem
              title={dataCurrent[0]?.title}
              modelName={dataCurrent[0]?.modelName}
              orderField={dataCurrent[0]?.orderField}
              limit={dataCurrent[0]?.limit}
            />
          </Col>
        </Row> */}

        {/* <Row>
          <Col xl={6}>
            <ChartDashboard
              title="Doanh thu hôm nay"
              typeDefault="bar"
              data={formatData(incomeChartDay, ["objectId", "total"])}
            />
          </Col>
        </Row> */}
      </Container>
    </div>
  );
}
